import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRetropieComponent } from './simple-icons-retropie.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRetropieComponent ],
    exports:      [ SimpleIconsRetropieComponent ],
    bootstrap:    []
})
export class SimpleIconsRetropieModule {}
